import { getTranslations } from 'data/global/translation'
import { useLanguage } from '../store/locale/hooks/useLanguage'

export const useTranslations = () => {
  const { language } = useLanguage()
  const translations = getTranslations({ language })

  return (key: string) => translations[key]
}
